export interface PageState {
  title: string;
  readonly: boolean;
  viewTitle: number;
}

export const initialState: PageState = {
  title: '',
  readonly: false,
  viewTitle: 1
};
